import React from 'react';

const SignUpInstead = ({ toggleSignUpOpen, border }) => (
	<div style={{
		width: '100%', marginTop: '1rem', paddingTop: '1rem', textAlign: 'center',
	}}
	>
		<p style={{ color: '#666666' }}> Need a new Account? <span className="secondary-color"> <a className="secondary-a" href="#" onClick={() => toggleSignUpOpen()}>Sign Up </a> </span> </p>
	</div>
);

export default SignUpInstead;
